
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

interface FooterProps {
  showProgramOverview?: boolean;
}

export default function Footer({ showProgramOverview = false }: FooterProps) {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-12 bg-charcoal text-white/80">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row justify-between items-center mb-12">
          <div className="mb-6 md:mb-0">
            <Link to="/" className="font-serif text-xl tracking-wide text-white hover:text-cream transition-colors">
              The Monastery Method™
            </Link>
          </div>
          
          <div className="flex flex-wrap gap-x-8 gap-y-4 justify-center md:justify-end text-sm">
            <Link to="/terms" className="hover:text-cream transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-cream transition-colors">Privacy</Link>
            <Link to="/contact" className="hover:text-cream transition-colors">Contact</Link>
            {showProgramOverview && (
              <Link 
                to="/program-overview" 
                className="text-white/50 hover:text-cream transition-colors flex items-center group"
              >
                <span>Program Details</span>
                <ArrowUpRight size={14} className="ml-1 opacity-70 group-hover:translate-x-[2px] group-hover:-translate-y-[2px] transition-transform" />
              </Link>
            )}
          </div>
        </div>
        
        <div className="text-center text-white/50 text-xs">
          <p>&copy; {currentYear} The Monastery Method™. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
